import { languages } from "./languages";

export default {
  location: {
    name: languages.referees.location
  },
  time: {
    name: languages.referees.time
  },
  divisions: {
    name: languages.divisions.divisions
  },
  maxMatches: {
    name: languages.referees.maxMatches
  },
  excludeTeams: {
    name: languages.referees.excludeTeams
  },
  role: {
    name: languages.referees.role
  }
};
